<template>
  <div>
    <form-title>手机号码</form-title>
    <info-panel>
      <el-form
        ref="creatStep1Form"
        :model="creatStep1Form"
        :rules="creatStep1Rules"
        label-width="100px"
      >
        <el-row
          :gutter="20"
          type="flex"
          align="middle"
        >
          <el-col :span="10">
            <el-form-item
              label="手机号码"
              prop="mobile"
            >
              <el-input v-model="creatStep1Form.mobile" />
            </el-form-item>
          </el-col>
          <el-col
            :span="5"
            class="btns"
          >
            <el-button @click="cancel">
              取消
            </el-button>
            <el-button
              type="primary"
              @click="next"
            >
              下一步
            </el-button>
          </el-col>
        </el-row>
      </el-form>
    </info-panel>
  </div>
</template>
<script>
import { validateMobile } from '@/util/validate';
import formTitle from '@/components/common/formTitle.vue';
import infoPanel from '@/components/common/infoPanel.vue';
import axClient from '@/services';

export default {
  name: 'CreatStep1',
  components: { formTitle, infoPanel },
  data() {
    return {
      creatStep1Form: {
        mobile: null,
      },
      creatStep1Rules: {
        mobile: [
          { required: true, message: '请输入手机号码', trigger: 'blur' },
          { validator: validateMobile, trigger: 'blur' },
        ],
      },
    };
  },
  methods: {
    // 取消
    cancel() {
      // this.creatStep1Form.mobile = null;
      window.history.back();
    },
    // 下一步
    next() {
      this.$refs.creatStep1Form.validate(async (valid) => {
        if (valid) {
          const data = await axClient.counselor.checkMobilePhone({ mobilePhone: this.creatStep1Form.mobile });
          if (data.id === -1) {
            this.$message.error('该手机号码不存在，请先注册口袋阿姨小程序');
            return;
          }
          if (data.id === -2) {
            this.$message.error('该手机号码已绑定账号');
            return;
          }
          const {
            id, mobilePhone, realName, wechatAvatarUrl, wechatNickName,
          } = data;
          this.$emit('next', {
            userId: id, mobilePhone, realName, wechatAvatarUrl, wechatNickName,
          });
        }
      });
    },
  },
};
</script>